/**
 * COLORDS — Hero.
 *
 * Iki is yapar:
 *   1) Slaydi ekran yuksekligine oturtur (altindaki kayan yaziyla birlikte
 *      ekrani tam doldursun, artik bosluk kalmasin).
 *   2) Kaydirmali gecisi yonetir: noktalar, oklar, otomatik gecis.
 *
 * Kaydirmanin kendisi CSS scroll-snap ile yapiliyor; parmakla kaydirma ve
 * kaydirma cubugu yerel olarak calisiyor. JS yalnizca kontrolleri ekliyor,
 * yani JS calismazsa slaytlar hala yatay kaydirilarak gezilebiliyor.
 */
(() => {
  const BREAKPOINT = 750; // altinda mobil duzen
  const MIN_HEIGHT = 420; // cok kisa pencerede slayt ezilmesin

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     1) Ekran yuksekligine oturtma
     ------------------------------------------------------------------ */

  const fitHero = (hero) => {
    const section = hero.closest('.shopify-section') || hero;

    if (window.innerWidth < BREAKPOINT) {
      hero.style.removeProperty('--chero-fill');
      return;
    }

    // Ustundeki her seyin toplami (duyuru cubugu + header). Bunlar sabit
    // degil: duyuru kapatilabiliyor, metni sarabiliyor, header logoya gore
    // buyuyor. Bu yuzden CSS'te sabit sayi yerine olcuyoruz.
    const above = section.getBoundingClientRect().top + window.scrollY;

    // Hemen alttaki bolum kayan yaziysa onun yuksekligini de dus.
    let below = 0;
    const next = section.nextElementSibling;
    if (next) {
      const marquee = next.querySelector('.cmarquee');
      if (marquee) below = marquee.getBoundingClientRect().height;
    }

    const target = Math.max(MIN_HEIGHT, Math.round(window.innerHeight - above - below));
    hero.style.setProperty('--chero-fill', target + 'px');
  };

  /* ------------------------------------------------------------------
     2) Kaydirmali gecis
     ------------------------------------------------------------------ */

  const initSlider = (hero) => {
    const track = hero.querySelector('[data-chero-track]');
    if (!track) return;

    const slides = Array.prototype.slice.call(hero.querySelectorAll('[data-chero-slide]'));
    if (slides.length < 2) return;

    const dots = Array.prototype.slice.call(hero.querySelectorAll('[data-chero-dot]'));
    const prev = hero.querySelector('[data-chero-prev]');
    const next = hero.querySelector('[data-chero-next]');

    let index = 0;
    let timer = null;
    // Ziyaretci kendi gecis yaptiysa otomatik gecis bir daha baslamaz.
    // Kontrolu eline alan kisinin altindan slayt kaymasin.
    let userTook = false;

    const paint = () => {
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const goTo = (i, smooth) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({
        left: slides[index].offsetLeft - track.offsetLeft,
        behavior: smooth === false || reduced() ? 'auto' : 'smooth',
      });
      paint();
    };

    // Kullanici kendi kaydirdiginda da noktalar dogru slaydi gostersin.
    let ticking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const w = track.clientWidth || 1;
          const i = Math.round(track.scrollLeft / w);
          if (i !== index && i >= 0 && i < slides.length) {
            index = i;
            paint();
          }
        });
      },
      { passive: true }
    );

    const takeOver = () => { userTook = true; stop(); };

    if (prev) prev.addEventListener('click', () => { takeOver(); goTo(index - 1); });
    if (next) next.addEventListener('click', () => { takeOver(); goTo(index + 1); });
    dots.forEach((d) =>
      d.addEventListener('click', () => {
        takeOver();
        goTo(parseInt(d.dataset.cheroDot, 10) || 0);
      })
    );

    // Klavye: sol/sag ok, odak bolumun icindeyken
    hero.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { takeOver(); goTo(index - 1); }
      else if (event.key === 'ArrowRight') { takeOver(); goTo(index + 1); }
    });

    // Parmakla kaydirma da devralma sayilir.
    track.addEventListener('pointerdown', () => { userTook = true; stop(); }, { passive: true });

    /* ---- otomatik gecis ---- */

    const wantsAuto = hero.dataset.autoplay === 'true';
    const interval = (parseInt(hero.dataset.interval, 10) || 6) * 1000;

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      // Hareket azaltma tercihi varsa otomatik gecis hic calismaz.
      if (!wantsAuto || userTook || reduced() || timer) return;
      timer = setInterval(() => goTo(index + 1), interval);
    }

    // Uzerindeyken, odaktayken veya sekme arka plandayken durur.
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop(); else start();
    });

    paint();
    start();
  };

  /* ------------------------------------------------------------------ */

  const setup = () => {
    document.querySelectorAll('[data-chero]').forEach((hero) => {
      if (hero.hasAttribute('data-chero-fill')) fitHero(hero);
      if (hero.dataset.cheroReady === '1') return;
      hero.dataset.cheroReady = '1';
      initSlider(hero);
    });
  };

  const refit = () => {
    document.querySelectorAll('[data-chero-fill]').forEach(fitHero);
  };

  let frame = null;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = null; refit(); });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  // Gorseller yuklenince header yuksekligi degisebiliyor.
  window.addEventListener('load', refit);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  // Theme Editor bolumu yeniden cizdiginde tekrar kur.
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', refit);
})();
